import { useApi } from "../api";

export const useCapacityService = () => {
  const api = useApi();

  return {
    /**
     * Obtener análisis de capacidad con soporte de rutas (NUEVO)
     */
    getCapacityAnalysisByRoute: async (
      operationId,
      year,
      month,
      operationRouteId = null
    ) => {
      try {
        const params = { year, month };

        if (operationRouteId) {
          params.operationRouteId = operationRouteId;
        }

        const response = await api.get(
          `/vehicle/operation/${operationId}/capacity/analysis`,
          { params }
        );
        return response.data;
      } catch (error) {
        console.error(
          "Error obteniendo análisis de capacidad por ruta:",
          error
        );
        throw error.response?.data || { message: error.message };
      }
    },
    /**
     * Obtener análisis de capacidad
     */
    getCapacityAnalysis: async (operationId, year, month) => {
      try {
        const response = await api.get(
          `/vehicle/operation/${operationId}/capacity/analysis`,
          {
            params: { year, month },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error obteniendo análisis de capacidad:", error);
        throw error.response?.data || { message: error.message };
      }
    },

    /**
     * Obtener historial de capacidad
     */
    getCapacityHistory: async (operationId, filters = {}) => {
      try {
        const response = await api.get(
          `/vehicle/operation/${operationId}/capacity/history`,
          {
            params: filters,
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error obteniendo historial de capacidad:", error);
        throw error.response?.data || { message: error.message };
      }
    },

    /**
     * Obtener dashboard de capacidad
     */
    getCapacityDashboard: async (operationId) => {
      try {
        const response = await api.get(
          `/vehicle/operation/${operationId}/capacity/dashboard`
        );
        return response.data;
      } catch (error) {
        console.error("Error obteniendo dashboard de capacidad:", error);
        throw error.response?.data || { message: error.message };
      }
    },

    /**
     * Exportar datos de capacidad
     */
    exportCapacityData: async (operationId, year, format = "json") => {
      try {
        const response = await api.get(
          `/vehicle/operation/${operationId}/capacity/export`,
          {
            params: { year, format },
            responseType: format === "csv" ? "blob" : "json",
          }
        );

        if (format === "csv") {
          // Crear enlace de descarga
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `capacidad_${operationId}_${year}.csv`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }

        return response.data;
      } catch (error) {
        console.error("Error exportando datos de capacidad:", error);
        throw error.response?.data || { message: error.message };
      }
    },
  };
};
